import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Dropdown, MenuItem } from 'react-bootstrap';
import Swipe from 'react-easy-swipe';

import Icon from 'components/ui/element/Icon';
import Notification from 'components/notifications/Notification';

import {NOTIFICATION_TYPE} from 'modules/notifications';

import {isMobile} from 'util/utils';
import {DEFAULT_VALUE, RADIX_DECIMAL} from 'util/constants';

import 'style/containers/notifications/notification-dropdown.scss';

const _dateOptions = {
    year:  'numeric',
    month: 'long',
    day:   '2-digit'
};

const _getUnread = notifications => notifications.filter(item => !item.read);


/**
 * Group the array of notifications by date
 * @param {Array} notifications The array of notifications
 */
const _groupNotifications = notifications => {
    const objNotifications = notifications.reduce((ret, item) => {
        const date = new Date(item.datetime);

        date.setHours(DEFAULT_VALUE, DEFAULT_VALUE, DEFAULT_VALUE, DEFAULT_VALUE);
        const dateTimestamp = date.getTime();
        let obj = ret[dateTimestamp];

        if (!obj) {
            obj = [];
            ret[dateTimestamp] = obj;
        }

        obj.push(item);

        return ret;
    }, {});

    return Object.keys(objNotifications).map(key => ({
        date:          parseInt(key, RADIX_DECIMAL),
        notifications: objNotifications[key]
    }));
};

/** Component to render a dropdown with all the notifications */
class NotificationDropdown extends Component {

    static propTypes = {
        intl:          PropTypes.object.isRequired, // Object for i18n
        notifications: PropTypes.array.isRequired, // Array with all the notifications to show
        onClose:       PropTypes.func.isRequired, // Listener when dropdown is closing
        onRemove:      PropTypes.func.isRequired, // Listener when remove was clicked
        onRemoveAll:   PropTypes.func.isRequired, // Listener when remove all was clicked
        onDownload:    PropTypes.func // Listern when user clicks download
    };

    state = {
        notifications: [], // The notifications already grouped
        unread:        [] // The unread notifications
    };

    /**
     * Group the notifications
     */
    componentWillMount() {
        const {notifications} = this.props;

        this.setState({
            notifications: _groupNotifications(notifications),
            unread:        _getUnread(notifications)
        });

        this.handleToggle = this.handleToggle.bind(this);
    }

    /**
     * Group the notifications
     */
    componentWillReceiveProps(nextProps) {
        const {notifications} = this.props;

        if (nextProps.notifications !== notifications) {
            this.setState({
                notifications: _groupNotifications(nextProps.notifications),
                unread:        _getUnread(nextProps.notifications)
            });
        }
    }

    /**
     * Send onClose event when is closing
     * @param {Boolean} open If dropdown is opening
     */
    handleToggle(open) {
        const {onClose} = this.props;

        !open && onClose && onClose();
    }

    /**
     * Hide the alert when swipping
     */
    handleSwipe(notification) {
        const {onRemove} = this.props;

        return () => {
            onRemove(notification);
        };
    }

    /**
     * Get the type to show in the bubble
     * @return {string} The type to show
     */
    getNotificationsType() {
        const {unread} = this.state;
        const priority = [
            NOTIFICATION_TYPE.ERROR,
            NOTIFICATION_TYPE.WARNING,
            NOTIFICATION_TYPE.SUCCESS,
            NOTIFICATION_TYPE.INFO
        ];

        return priority.reduce((ret, type) => ret || (unread.find(notification => notification.type === type) ? type : ''), '');
    }

    renderEmpty() {
        const {
            intl:{formatMessage}
        } = this.props;

        return (
            <MenuItem>
                {formatMessage({id: 'msg.no_new_notifications'})}
            </MenuItem>
        );
    }

    renderNotifications() {
        const {intl: {formatMessage, formatDate}, onRemove, onRemoveAll, onDownload} = this.props;
        const {notifications} = this.state;

        const removeAll = (
            <MenuItem
                key="remove-all"
                className="notifications-dropdown-removeall"
                onClick={onRemoveAll}
            >
                {formatMessage({id: 'label.notifications.removeall'})}
            </MenuItem>
        );
        const dateGroup = item => {

            const date = formatDate(item.date, _dateOptions);

            return (
                <MenuItem key={`header-${item.date}`} header >
                    {date}
                </MenuItem>
            );
        };
        const _renderNotification = notification => (
            <Swipe
                key={notification.id}
                onSwipeLeft={this.handleSwipe(notification)}
                onSwipeRight={this.handleSwipe(notification)}
            >
                <MenuItem className={notification.read ? '' : 'unread'}>
                    <Notification notification={notification} onRemove={onRemove} onDownload={onDownload} />
                </MenuItem>
            </Swipe>
        );

        return [removeAll]
            .concat(notifications.reduce((ret, item) => ret
                .concat([dateGroup(item)])
                .concat(item.notifications.map(_renderNotification.bind(this))), []));
    }

    renderList() {
        const {notifications} = this.props;

        return notifications.length ?
            this.renderNotifications() :
            this.renderEmpty();
    }

    renderType() {
        const {unread} = this.state;

        return unread.length ?
            <div className={`notification-dropdown-type ${this.getNotificationsType()}`}>
                {unread.length}
            </div> :
            null;
    }

    renderCount() {
        const {unread} = this.state;

        return unread.length ?
            <span className={`notification-dropdown-count`}>{unread.length}</span> :
            null;
    }

    render() {
        const {notifications} = this.props;
        const _classMenu = `${notifications.length ? '' : 'empty'} ${isMobile() ? 'dropdown-menu-left' : 'dropdown-menu-right'}`;

        const style = {
            backgroundColor: 'transparent',
            borderColor:     'transparent',
            boxShadow:       '0 0 0 rgba(0, 0, 0, 0.1)'
        };

        return (
            <div>
                <Dropdown
                    id="dd-alerts"

                    className="notification-dropdown flat"
                    componentClass="div"
                    onToggle={this.handleToggle}
                >
                    <Dropdown.Toggle noCaret style={style}>
                        {this.renderType()}
                        <Icon name="bell-o" lg />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className={_classMenu}>
                        {this.renderList()}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }
}

export default injectIntl(NotificationDropdown);



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationDropdown.jsx